module.exports = __webpack_public_path__ + "static/media/app.aaef1287.svg";